import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Wrapper from './Wrapper';
import Thanks from './Thanks';

function App() {
  return <>
   <Router>
    <Routes>
   
    <Route path="/" index element={<Wrapper/>}/>
    <Route path="/תודה" index element={<Thanks/>}/>
   
 </Routes>
 </Router>
  </>
}

export default App;